import { environment } from '@environment';
import { ALGOLIA_SERVICE_TOKEN } from '@wizbii-utils/angular/algolia';
import {
  ABTEST_API_CONFIG,
  AbTestWebservice,
  ACCOUNT_API_CONFIG,
  AccountWebservice,
  AlgoliaWebservice,
  AUTHENTICATION_API_CONFIG,
  AuthenticationWebservice,
  BANKING_PROCESSOR_API_CONFIG,
  BankingPartnerWebservice,
  BankingPersonalInformationWebservice,
  BankingTrackWebservice,
  BankingUserWebservice,
  CHATBOT_API_CONFIG,
  ChatbotWebservice,
  CityWebservice,
  CONTACT_API_CONFIG,
  ContactWebservice,
  CONTENT_API_CONFIG,
  ContentWebservice,
  FaqWebservice,
  FIBII_API_CONFIG,
  FibiiWebservice,
  FILE_API_CONFIG,
  FileWebservice,
  PLACE_API_CONFIG,
  STRAPI_API_CONFIG,
  SUGGESTIONS_API_CONFIG,
  SuggestionsWebservice,
} from '@wizbii-utils/angular/webservices';

export const wizbiiWebservicesConfig = [
  AlgoliaWebservice,
  {
    provide: ALGOLIA_SERVICE_TOKEN,
    useValue: {
      applicationId: environment.algolia.applicationId,
      apiKey: environment.algolia.apiKey,
      prefix: environment.platform,
      options: {},
    },
  },
  {
    provide: AUTHENTICATION_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.authentication,
      locale: environment.i18n.locale,
      cookieDomains: environment.cookieDomains,
    },
  },
  AuthenticationWebservice,
  {
    provide: CONTENT_API_CONFIG,
    useValue: {
      baseUrl: environment.api.content,
    },
  },
  ContentWebservice,
  {
    provide: ACCOUNT_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.account,
      locale: environment.i18n.locale,
      baseUrlHost: environment.api.account,
    },
  },
  AccountWebservice,
  {
    provide: CONTACT_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.contact,
      locale: environment.i18n.locale,
    },
  },
  ContactWebservice,
  {
    provide: SUGGESTIONS_API_CONFIG,
    useValue: {
      baseUrl: environment.api.suggestion,
    },
  },
  SuggestionsWebservice,
  {
    provide: FILE_API_CONFIG,
    useValue: {
      baseUrl: environment.api.file,
      googleStorageUrl: environment.urls.googleStorage,
      wizbiiFilesBucket: environment.wizbiiFiles,
    },
  },
  FileWebservice,
  {
    provide: FIBII_API_CONFIG,
    useValue: {
      baseUrl: environment.api.fibii,
    },
  },
  FibiiWebservice,
  {
    provide: PLACE_API_CONFIG,
    useValue: {
      baseUrl: environment.api.place,
    },
  },
  CityWebservice,
  {
    provide: BANKING_PROCESSOR_API_CONFIG,
    useValue: {
      baseUrl: environment.api.bankingProcessor,
    },
  },
  AbTestWebservice,
  {
    provide: ABTEST_API_CONFIG,
    useValue: {
      baseUrl: environment.api.abtest,
      appId: 'wizbii-money',
    },
  },
  ChatbotWebservice,
  {
    provide: CHATBOT_API_CONFIG,
    useValue: {
      baseUrl: environment.api.chatbot,
    },
  },
  BankingUserWebservice,
  BankingPartnerWebservice,
  BankingPersonalInformationWebservice,
  BankingTrackWebservice,
  {
    provide: STRAPI_API_CONFIG,
    useValue: {
      baseUrl: environment.api.strapi,
      lang: environment.i18n.lang,
    },
  },
  FaqWebservice,
];
